export interface ApiResponse<T> {
  status: 'success' | 'fail' | 'error' | 'starting';
  message: string;
  data?: T | null;
  error_code?: number;
}


export interface SubmitResponse {
  status: 'success' | 'fail' | 'error' | 'starting';
  message: string;
  data?: any;
  error_code?: number;
}

export enum LangCode {
  English = 'en',
  Arabic = 'ar'
}
export enum LanguageCode {
  English = 'en-us',
  Arabic = 'ar-ae'
}
